import Dispatcher from './../Dispatcher';
import DailyBonusActionTypes from './Types/DailyBonusActionTypes';

const DailyBonusActionCreator = {
	reload: function () {
		Dispatcher.dispatch({
			type: DailyBonusActionTypes.RELOAD,
		});
	},

	/**
	 * @param {Number} limit
	 * @param {String} order
	 */
	loadInteractiveContent: function (limit, order) {
		Dispatcher.dispatch({
			type: DailyBonusActionTypes.LOAD_INTERACTIVE_CONTENT,
			limit,
			order,
		});
	},

	/**
	 * @param {String} date
	 * @param {Boolean} isMobile
	 */
	requestEventConfig: function (date, isMobile = false) {
		Dispatcher.dispatch({
			type: DailyBonusActionTypes.LOAD_EVENT_CONFIG,
			date,
			isMobile,
		});
	},
};

export default DailyBonusActionCreator;
